<template>
    <div class="page_container">

        <NovoUsuario v-if="showCadastro" @fecharComponente="closeCadastrar" />
        <EditarUsuario v-if="showEditar" :usuario="user"  @fecharComponente="closeCadastrar" />
        <mudarsenha :usuario="user" @fecharComponente="fecharTelaComponente" v-if="menuSelected == 2"/>
        <mudarpermissao :usuario="user" @fecharComponente="fecharTelaComponente" v-if="menuSelected == 3"/>

        <div>
            <div class="formPosition">
                <v-card class="page_container">
                    <v-card-title style="background-color: #006699; color: white"></v-card-title>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

                    <v-card-title>
                        <v-row>
                            <v-col col="4"><span>Painel de Usuário</span></v-col>
                            <v-col col="4">
                                <v-text-field v-model="search" append-icon="search" label="Pesquisar usuário"
                                    single-line hide-details @input="filtrarUsuario">
                                </v-text-field>
                            </v-col>
                            <v-col col="4" v-if="funcaoPorROle.verificarFuncao(18)">
                                <v-btn color="primary" @click="showUsuarioForms"
                                    style=" font-size: 12px;">Novo Usuário
                                    <v-icon>add</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>


                    <template>
                        <v-data-table :headers="header" :items="filteredUsers">
                            <template v-slot:item.action="{ item }">
                                <v-menu bottom origin="center center" transition="scale-transition">
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab dark color="teal" style="color: white" v-on="on">
                                            <v-icon>menu</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item v-if="funcaoPorROle.verificarFuncao(19)"
                                            @click="selecionarMenu(item, 2)"><v-icon color="primary darken-3" small
                                                class="mr-2" @click="editItem(item)">lock</v-icon>Mudar
                                            Senha</v-list-item>
                                        <v-list-item v-if="funcaoPorROle.verificarFuncao(20)"
                                            @click="selecionarMenu(item, 3)">
                                            <v-icon color="primary darken-3" small
                                                class="mr-2">crop_rotate</v-icon>Mudar
                                            Permissão</v-list-item>
                                        <v-list-item
                                            @click="showEditForm(item)">
                                            <v-icon color="blue darken-3" small
                                                class="mr-2">edit</v-icon>Editar Dados</v-list-item>
                                        <v-list-item v-if="funcaoPorROle.verificarFuncao(21)"
                                            @click="selecionarMenu(item, 4)">
                                            <v-icon color="primary darken-3" small class="mr-2">person</v-icon>
                                            <span style="color: green" v-if="item.enable == 0">Activar</span>
                                            <span style="color: red" v-if="item.enable == 1">Inactivar</span>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>

                            <template v-slot:item.enable="{ item }">
                                <span v-if="item.enable == 1" style="color: green; font-weight: bold">Activo(a)</span>
                                <span v-else style="color: red; font-weight: bold">Inactivo(a)</span>
                            </template>
                            <template v-slot:item.index="{ item }">
                                <span> {{ usuarios.indexOf(item) + 1 }}</span>
                            </template>
                        </v-data-table>
                    </template>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import funcaoPorROle from '../../utilitarios/funcao.untilitario'
const ls = require("local-storage");
import axios from "@/plugins/axios";
import NovoUsuario from "./components/NovoUsuario.vue";
import mudarsenha from "./components/mudarsenha.vue";
import mudarpermissao from "./components/mudarpermissao.vue";
import EditarUsuario from "./components/EditarUsuario.vue";
export default {
    components: {
        NovoUsuario,
        mudarsenha,
        mudarpermissao,
        EditarUsuario
    },
    data: () => ({
        showCadastro: false,
        showEditar: false,
        user: null,
        funcaoPorROle: funcaoPorROle,
        menuSelected: 0,
        role_activo: ls.get("role"),
        search: "",
        overlay: false,
        overlay2: false,
        usuarios: [],
        dialog: false,
        valid: true,
        filteredUsers: [],
        permissoes: null,
        header: [
            { text: "#", value: "index" },
            {
                text: "Nome",
                align: "start",
                sortable: false,
                value: "nomeUsuario",
            },
            { text: "Email", value: "username" },
            { text: "Role", value: "role" },
            { text: "Estado", value: "enable" },
            { text: "Autor", value: "autor" },
            { text: "Ação", value: "action" },
        ]
    }),

    created() {
        this.Initialize();
    },

    computed: {
        userNivel() {
            return ls.get("nivel_user");
        },

         fkUsuario() {
            return ls.get("pkUsuario");
        },
    },

    methods: {
        async Initialize() {
            this.overlay = true;
            try {
                this.usuarios = await axios
                    .get("/usuarioFindAll")
                    .then((res) => res.data);
                if (this.userNivel)
                    this.usuarios = this.usuarios.filter(
                        (u) => u.nivel >= this.userNivel
                    );
                this.filteredUsers = this.usuarios
            } catch (error) {
                Swal.fire("Informação", "Erro ao carregar os usuários", "error");
            } finally {
                this.overlay = false;
            }
        },

        showUsuarioForms() {
            this.showCadastro = true;
        },

        showEditForm(item) {
            this.user = item;
            this.showEditar = true;
        },

        closeCadastrar(bool) {
            this.showCadastro = false;
             this.showEditar = false;
            if (bool) {
                this.Initialize();
            }
        },

        filtrarUsuario() {
            if (this.search.length) {
                const searchRegex = new RegExp(this.search, 'i');
                this.filteredUsers = this.usuarios.filter(user =>
                    searchRegex.test(user.username) || searchRegex.test(user.nomeUsuario)
                );
            } else {
                this.filteredUsers = this.usuarios;
            }
        },

        selecionarMenu(item, opcao) {
            this.user = item;
            if (opcao === 2) this.menuSelected = 2;
            else if (opcao === 3) {
                this.menuSelected = 3;
            } else if (opcao === 4) {
                this.actualizarStatus(item);
            }
        },
        async actualizarStatus(item) {
                        
            try {
                let params = { 
                    pkUsuario: item.fkUsuario, 
                    fkUsuario: this.fkUsuario,
                    email: item.Usuario_username,
                 };
                let msg = await axios
                    .post("/mudarStatusByUser", params)
                    .then((res) => res.data);
                if (msg && msg.affectedRows) {
                    this.Initialize();
                    Swal.fire("Informação", "Operação realizada com sucesso", "success");
                }
            } catch (error) {
                Swal.fire(
                    "Informação",
                    "Ocorreu um erro ao alterar o status do usuário",
                    "error"
                );
            }
        },
        fecharTelaComponente() {
            this.menuSelected = 0;
            this.Initialize();
        },
    },
};
</script>

<style scoped>
.page_container {
    width: 95%;
    margin: 0 auto;
}
</style>
